import { render } from "./GoBackTitle.vue?vue&type=template&id=3a832937"
import script from "./GoBackTitle.vue?vue&type=script&lang=js"
export * from "./GoBackTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__